module.exports = __webpack_public_path__ + "img/6_39.040343df.png";